export default "今有一言。曰「「犀」」。名之曰「境」。\n\n注曰「「鑒。同Javascript之eval也。」」\n今有一術。名之曰「鑒」。欲行是術。必先得一言。曰「言」。乃行是術曰。\n\t施「eval」於「言」。乃得矣。\n是謂「鑒」之術也。";